export enum ActivityLogEntityType {
  PURCHASE_REQUEST = "PURCHASE_REQUEST",
  PURCHASE_REQUEST_ITEM = "PURCHASE_REQUEST_ITEM",
  ORDER = "ORDER",
  OFFER = "OFFER",
}

export enum ActivityLogAction {
  PURCHASE_REQUEST_CREATED = "PURCHASE_REQUEST_CREATED",
  PURCHASE_REQUEST_STATUS_CHANGED = "PURCHASE_REQUEST_STATUS_CHANGED",
  PURCHASE_REQUEST_ITEM_CREATED = "PURCHASE_REQUEST_ITEM_CREATED",
  PURCHASE_REQUEST_ITEM_STATUS_CHANGED = "PURCHASE_REQUEST_ITEM_STATUS_CHANGED",
  ORDER_CREATED = "ORDER_CREATED",
  ORDER_STATE_CHANGED = "ORDER_STATE_CHANGED",
  OFFER_SUBMITTED = "OFFER_SUBMITTED",
  OFFER_AWARDED = "OFFER_AWARDED",
  SUPPLIER_INVITED = "SUPPLIER_INVITED",
  SECOND_ROUND_LAUNCHED = "SECOND_ROUND_LAUNCHED",
}

export interface ActivityLog {
  id: string;
  createdAt: string;
  updatedAt: string;
  entityType: ActivityLogEntityType;
  entityId: string;
  action: ActivityLogAction;
  previousState: string | null;
  newState: string | null;
  performedBy: {
    id: string;
    fullName: string;
    email: string;
  } | null;
  company: {
    id: string;
    name: string;
  } | null;
  materialName: string | null;
  purchaseRequestId: string | null;
  orderId: string | null;
  description: string | null;
}
